<template>
  <b-container fluid>
    <table-responsive responsive ref="tableResponsive" :items="pakete" :field-definition="fields">
      <template v-slot:declaration="data">
        <b-btn size="sm" @click.stop="openSelbstdeklaration(data.item.id)" v-if="buttonType(data.item) === 'std'">
          {{ $i18n.t("Bearbeiten") }}
        </b-btn>
        <b-btn size="sm" v-b-modal.info v-if="buttonType(data.item) !== 'std'">
          {{ buttonInfoLabel() }}
        </b-btn>
        <b-modal id="info" ok-only v-if="buttonType(data.item) !== 'std'" :title="buttonInfoLabel()">
          <p style="white-space: normal;">{{ modalInfoText() }}</p>
        </b-modal>
      </template>
      <!--
      <template v-slot:freigabeZeile="data">
        <b-btn size="sm" @click.stop="openFreigabe(data.value)" v-if="(Array.isArray(data.item.organisationen))">
          {{ $i18n.t("Freigeben") }}
        </b-btn>
      </template>
      -->
      <!--
      <template v-slot:funktion="data">
        <b-btn size="sm" class="ml-2" @click.stop="openDaten(data.item)"
               v-if="((data.item.id === 1) && (data.item.daten.length > 0))">
          {{ $t('Daten') }}</b-btn>
      </template>
      -->
      <!--
      <template v-slot:freigaben="data">
        <div v-if="data.item.freigaben.length === 0">{{ $t('KeineM').toLowerCase() }}</div>
        <div
          v-for="freigabe in data.item.freigaben"
          :id="'colFreigabe'+data.item.id"
          :key="freigabe.id"
          :class="{ active: freigabe.bis === null }"
        >{{ convertTime(freigabe.von, "") }}{{ convertTime(freigabe.bis, " - ") }}</div>
        <b-popover
          :target="'colFreigabe'+data.item.id"
          triggers="hover click"
          placement="left"
          v-if="(data.item.id === 2)"
        >{{ $t('DatumLetzteAenderung') }}</b-popover>
      </template>
      -->
    </table-responsive>

    <selbstdeklaration-gt v-if="pakete.filter(p => p.id === 2).length > 0"></selbstdeklaration-gt>
    <selbstdeklaration-cmp v-if="pakete.filter(p => p.id === 3).length > 0">></selbstdeklaration-cmp>
    <selbstdeklaration-mooh v-if="pakete.filter(p => p.id === 4).length > 0">></selbstdeklaration-mooh>
    <freigabe-dialog></freigabe-dialog>

    <!-- Status GT auch prüfen GT_RAUS -->
    <!--
    <b-card :title="$t('Datenpakete_GT_BOM_Titel')" v-if="showUebergang()">
      <b-card-text v-html="$t('Datenpakete_GT_BOM_Einleitungssatz')"></b-card-text>
      <b-form>
        <b-form-checkbox id="bomAGB" name="bomAGB" v-model="bom.agb" required :state="bom.agb">
          <p v-html="$t('Datenpakete_GT_BOM_AGB')"></p>
        </b-form-checkbox>
        <b-button :disabled="!bom.agb" @click.stop="setUebergangGT()">{{
            $t('Datenpakete_GT_BOM_Registrieren')
          }}
        </b-button>
      </b-form>
    </b-card>
    -->
    <!--
    <b-modal id="selbstdeklarationModal" :title="paket.name[$i18n.locale]" v-if="paketeOhneSD.length > 0">
      <p v-html="paket.text[$i18n.locale]"></p>
      <b-card :header="$t('Kriterien')" class="mb-3">
        <b-list-group v-if="paket.id === 1">
          <div v-for="kriterium in paket.kriterien" :key="kriterium">
            <b-list-group-item
              href="#"
              :id="'krit'+kriterium"
            >{{ kriterien[kriterium].code[$i18n.locale] }}</b-list-group-item>
            <b-popover
              :title="kriterien[kriterium].name[$i18n.locale]"
              :target="'krit'+kriterium"
              triggers="hover click blur"
            >{{ kriterien[kriterium].text[$i18n.locale] }}</b-popover>
          </div>
        </b-list-group>
      </b-card>
      <b-form validated>
        <b-form-checkbox id="cbAGB" name="cbAGB" v-model="AGB" required :state="AGB">
          <p v-html="text_agb"></p>
        </b-form-checkbox>
      </b-form>
      <div slot="modal-footer">
        <b-btn @click.stop="hideSelbstdeklaration()">{{ $t('Abbrechen') }}</b-btn>
        <b-btn
          @click.stop="saveFreigabe()"
          variant="primary"
          id="btnSave"
          :disabled="! AGB"
        >{{ buttonEditLabel(paket) }}</b-btn>

      </div>
    </b-modal>
    -->
    <!--
    <b-modal
      id="datenModal"
      ok-only
      :title="paket.name[$i18n.locale]"
      v-if="paketeOhneSD.length > 0"
    >
      <p v-html="paket.text[$i18n.locale]"></p>
      <b-card :header="$t('KontrolldatenAGIS') + ' ' + jahr" class="mb-3">
        <b-list-group v-if="paket.id === 1">
          <div v-for="kriterium in paket.kriterien" :key="kriterium">
            <b-list-group-item href="#" :id="'data'+kriterium">
              <div class="d-flex justify-content-between">
                <div class="p">{{ kriterien[kriterium].code[$i18n.locale] }}</div>
                <div class="p">{{ valueForKriterium(kriterium) }}</div>
              </div>
            </b-list-group-item>
            <b-popover
              :title="kriterien[kriterium].name[$i18n.locale]"
              :target="'data'+kriterium"
              triggers="hover click blur"
            >{{ kriterien[kriterium].text[$i18n.locale] }}</b-popover>
          </div>
        </b-list-group>
      </b-card>
    </b-modal>
    -->
  </b-container>
</template>

<script>
import TableResponsive from "../tableResponsive.vue";
import FreigabeDialog from "./FreigabeDialog.vue";
import SelbstdeklarationGT from "./SelbstdeklarationGT.vue";
import SelbstdeklarationCMP from "./SelbstdeklarationCMP.vue";
import SelbstdeklarationMA from "./SelbstdeklarationMA.vue";
import moment from "moment";
import {bus, i18n} from "@/main";

export default {
  name: "datenpakete",
  props: {
    einladung: {
      // einladung wird via routeparams von EinladungZeile beschrieben
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      paketFilter: 0,
      paket: {
        id: 0,
        text: {de: "", fr: "", it: ""},
        name: {de: "", fr: "", it: ""},
        infos: {de: "", fr: "", it: ""},
        organisation: "",
        organisationen: [],
        freigaben: [],
        kriterien: [],
      },
      //AGB: false,
      bom: {
        agb: false
      },
      fields: [
        {
          key: "name",
          label: this.$t("Datenpaket"),
          formatter: value => {
            return value[this.$i18n.locale];
          }
        },
        {
          key: "organisation",
          label: this.$t("Organisation"),
        },
        {
          key: "status.text",
          label: this.$t("Status"),
          formatter: value => {
            if (!value) return ''
            return value[this.$i18n.locale];
          }
        },
        {
          key: "status.datum",
          label: this.$t("Datum"),
          formatter: value => {
            if (!value) return ''
            return moment(Date.parse(value)).format("DD.MM.YYYY")
          }
        },
        {
          key: "declaration", //1,0
          label: "",
        },
        /*
        { key: "freigabeZeile",
          label: this.$t("Freigaben"),
          formatter: (value,key, item) => {
            return item.id
          }
        },
        */
        /*
        { key: "funktion", label: "" }
        */
      ]
    };
  },
  computed: {
    pakete() {
      return this.$store.state.datenpaketeStore.pakete;
    },
    /*
    kriterien() {
      return this.$store.state.datenpaketeStore.kriterien.dict;
    },
    paketeOhneSD() {
      return this.$store.state.datenpaketeStore.pakete.filter(
        dp => dp.id !== 2 && dp.id !== 3
      );
    },
    coop() {
      // reactivity on nested structures pakete[n].kriterien[m].value hat nicht funktioniert
      return this.$store.state.datenpaketeStore.CMP;
    },
    jahr() {
      return moment().year();
    },
    paketAuswahl() {
        let allePakete = [ { "id": 0, "name": i18n.t("Alle").toLowerCase() } ]
        for (var i = 0; i < this.$store.state.datenpaketeStore.pakete.length; i++ )
            allePakete.push( {
                "id": this.$store.state.datenpaketeStore.pakete[i].id,
                "name": this.$store.state.datenpaketeStore.pakete[i].name[i18n.locale] } )
        return allePakete
    },
    text_agb() {
      var agb = i18n.t("Datenpakete_AGB");
      return agb.replace("<org>", this.$t(this.paket.organisation));
    }
    */
  },
  methods: {
    async init() {
      //await this.$store.dispatch("loadKriterien");
      await this.$store.dispatch("loadPakete");
      //if (this.$store.state.datenpaketeStore.pakete.filter(dp => dp.id === 2).length) await this.$store.dispatch("loadGT")
      //if( this.$store.state.datenpaketeStore.pakete.filter(dp => dp.id === 3).length) await this.$store.dispatch("loadCMP")

      // param einladung wird via Einladung angesteuert : Einladungzeile.vue resp classes/einladungen/organisation/routeconfig.cfc
      // params: { einladung:{paketid:2,PerID:domid, name:'#domname#',step:3}
      if (typeof this.einladung.paketid === "number") {
        this.$store.dispatch("addGTExtraOrg", this.einladung.freigabe);
        let paketX = this.pakete.filter(p => p.id === this.einladung.paketid)[0];
        await this.openSelbstdeklaration(paketX);
        if (paketX.freigaben.length > 0) {
          // nur wenn GT bereits ausgefüllt ..
          bus.$emit("GTjumpStep", this.einladung.step);
        }
      }
    },
    filter(item) {
      return this.paketFilter === 0 || item.id === this.paketFilter;
    },
    /*
    convertTime(value, prefix) {
      return value != null ? prefix + moment(value).format("DD.MM.YYYY") : "";
    },
    valueForKriterium(kriterium) {
      if (this.paket.daten.length === 0) return "";
      let value = this.paket.daten.filter(d => d.id === kriterium)[0].value;
      if (value === 1) return§ i18n.t("Ja");
      if (value === -1) return i18n.t("Nein");
      return "";
    },
    buttonEditLabel(paket) {
      try {
        if (paket.id === 2 || paket.id === 3 || paket.id === 4) return i18n.t("Bearbeiten");
        return paket.freigaben.length === 0 || paket.freigaben[0].bis !== null
            ? i18n.t("Freigeben")
            : i18n.t("Widerrufen");
      } catch (e) {
        return "Paket noch nicht geladen";
      }
    },
    */
    buttonType(paket) {
      if (
          (paket.id === 2 || paket.id === 4) &&
          this.$store.state.userStore.userBZG.toString().length > 0
      )
        return "bzg";
      else if (
          (paket.id === 2 || paket.id === 4) &&
          this.$store.state.betriebeStore.betriebe.list.filter(
              b => b.BTRFRMID === 114
          ).length > 0
      )
        return "tank";
      else return "std";
    },
    buttonInfoLabel() {
      if (this.$store.state.userStore.userBZG.toString().length > 0)
        return i18n.t("SieheBZG");
      else if (
          this.$store.state.betriebeStore.betriebe.list.filter(
              b => b.BTRFRMID === 114
          ).length > 0
      )
        return i18n.t("SieheGJB");
      else return "...";
    },
    modalInfoText() {
      if (this.$store.state.userStore.userBZG.toString().length > 0)
        return i18n
            .t("MitgliedBZGX1")
            .replace("%1", this.$store.state.userStore.userBZG.toString());
      else if (
          this.$store.state.betriebeStore.betriebe.list.filter(
              b => b.BTRFRMID === 114
          ).length > 0
      )
        return i18n.t("GTaufGJB");
      else return "...";
    },
    async openSelbstdeklaration(paketId) {
      //this.AGB = false;
      if (paketId === 2) {
        /* Grüner Teppich */
        await this.$store.dispatch("loadGT");
        this.$root.$emit("bv::show::modal", "selbstdeklarationGTmodal", paketId);
      } else if (paketId === 3) {
        /* Coop Milch Programm (Emmi) */
        await this.$store.dispatch("loadCMP");
        this.$root.$emit("bv::show::modal", "selbstdeklarationCMPmodal", paketId);
      } else if (paketId === 4) {
        /* Mooh Auslese */
        // await this.$store.dispatch("loadMA");
        this.$root.$emit("bv::show::modal", "selbstdeklarationMAmodal", paketId);
      } else if (paketId === 5) {
        /* Grüner Teppich Sömmerung */
        this.$root.$emit('freigabeDialog', paketId)
      } else if (paketId === 6) {
        /* Grüner Teppich Übergangsfrist */
        this.$root.$emit('freigabeDialog', paketId)
      } else {
        // this.$root.$emit("bv::show::modal", "selbstdeklarationGTmodal", paketId);
      }
    },
    openFreigabe(id) {
      console.log('id:' + id)
      this.$root.$emit('freigabeDialog', id)
    },
    /*
    hideSelbstdeklaration() {
      this.$root.$emit("bv::hide::modal", "selbstdeklarationModal");
    },
    async saveFreigabe() {
      if (this.AGB) {
        this.einladung={};//sonst loop der dialog immer wieder zu step 3
        await this.$store.dispatch("setFreigabe", this.paket);
        this.$root.$emit("bv::hide::modal", "selbstdeklarationModal");

      }
    },
    async openDaten(paket) {
      if (paket.id === 2) {
        // Grüner Teppich
      } else if (paket.id === 3) {
        // Coop Milch Programm (Emmi)
      } else {
        this.paket = paket;
        this.$root.$emit("bv::show::modal", "datenModal");
      }
    },
    hideDaten() {
      this.$root.$emit("bv::hide::modal", "datenModal");
    },
    */
    /*
    showUebergang() {
      return this.$store.state.datenpaketeStore.GT.arrayRef !== null
          && this.$store.state.datenpaketeStore.GT.status !== -4
    },
    async setUebergangGT() {
      this.$store.dispatch("setUebergangGT");
      // this.bom.angemeldet = true
    },
    */
  },
  components: {
    "table-responsive": TableResponsive,
    "freigabe-dialog": FreigabeDialog,
    "selbstdeklaration-gt": SelbstdeklarationGT,
    "selbstdeklaration-cmp": SelbstdeklarationCMP,
    "selbstdeklaration-mooh": SelbstdeklarationMA
  },
  created() {
    let self = this;
    bus.$on("paketSaved", this.init);
    this.$nextTick(async function () {
      self.init();
    });
  },
  mounted() {
  },
  updated() {
  }
};
</script>

<style scoped>
.active {
  font-weight: bold;
}
</style>